module.exports.reportData = {
  info: {
    campaignName: 'BLADERUNNER 2049',
    influencerName: 'Callux',
    reportDate: 'Oct 1st 2017',
    hasLogo: true,
  },
  youtubeViews: 272389,
  youtubeEngagements: 22758,
  supportingActivity: [
    {
      platform: 'instagram',
      url: 'https://www.instagram.com/p/BZEmn8FnpUZ',
      title: 'Learning to drive episodes are gonna get a lot more interesting...',
      views: 231437,
      engagements: 28322,
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/913372887284948993',
      title: 'NEW VIDEOOOOOOO FINALLY',
      views: 98390,
      engagements: 3634,
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/Callux/status/913372887284948993',
      title: 'I liked a @YouTube video http://youtu.be/itgosOcMXqc?a  THE TRUTH ABOUT MY FUTURE...',
      views: 70723,
      engagements: 1836,
    },
    {
      platform: 'snapchat',
      title: 'Snap 1: video at event ',
      views: 97276,
    },
    {
      platform: 'snapchat',
      title: 'Snap 2: video at car',
      views: 95629,
    },
    {
      platform: 'snapchat',
      title: 'Snap 3: video in car',
      views: 94018,
    },
    {
      platform: 'snapchat',
      title: 'Snap 4: photo on car',
      views: 91892,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/callux-bladerunner-2017.js